const assignmentPriceMethodList = [
  {
    id: 1,
    name: 'Actual cost'
  },
  {
    id: 2,
    name: 'Rate card'
  }
];

export default assignmentPriceMethodList;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/drop-down-tables/assignmentPriceMethodList.js